const redirect = (event) => {
    const { key, newValue } = event;
    if (key === 'goTo' && !!newValue) {
        const tenant = newValue.split('@').at(0);
        const authTenant = window.sessionStorage.getItem('authTenant');
        if (tenant && tenant === authTenant) {
            window.location.href = `/${authTenant}`;
        }
    }
};

window.addEventListener('storage', redirect);
